document.querySelectorAll('.sibling_link input').forEach((link) => {
  link.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    var elem = e.target;
    var href = elem.dataset.connectedProductUrl;
    if(href) {
      window.location.href = href;
    }
  });
});